import {
  //CREATE
  CREATE_ENQUIRY_FAILED,
  CREATE_ENQUIRY_SUCCESS,
  CREATE_ENQUIRY_START,
  ////////////

  //CALLLIST
  ADD_ENQUIRY_TO_CALLLIST_START,
  ADD_ENQUIRY_TO_CALLLIST_SUCCUSS,
  REMOVE_ENQUIRY_FROM_CALLLIST_START,
  REMOVE_ENQUIRY_FROM_CALLLIST_SUCCESS,

  //WHITEBOARD
  ADD_ENQUIRY_TO_WHITEBOARD_START,
  ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS,
  REMOVE_ENQUIRY_FROM_WHITEBOARD_START,
  REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS,

  //INVESTOR
  ADD_ENQUIRY_TO_INVESTOR_START,
  ADD_ENQUIRY_TO_INVESTOR_SUCCESS,
  REMOVE_ENQUIRY_FROM_INVESTOR_START,
  REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS,
  ////////////

  //DELETE
  DELETE_ENQUIRY_FAILED,
  DELETE_ENQUIRY_SUCCESS,
  DELETE_ENQUIRY_START,
  ////////////

  //UPDATE
  UPDATE_ENQUIRY_FAILED,
  UPDATE_ENQUIRY_SUCCESS,
  UPDATE_ENQUIRY_START,
  UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
  CLEAR_PULLFORWARD_ENQUIRY_SUCCESS,
  ////////////

  //ERROR MANAGEMENT
  CLEAR_ENQUIRY_ERROR,
  ENQUIRY_ERROR,
  ////////////

  ///FETCH
  FETCH_ENQUIRY_START,
  FETCH_ENQUIRY_SUCCESS,
  FETCH_ENQUIRY_FAILED,
  //////
  FETCH_ENQUIRIES_START,
  FETCH_ENQUIRIES_SUCCESS,
  FETCH_ENQUIRIES_FAILED,

  //ARCHIVE ENQUIRY
  ARCHIVE_ENQUIRY_START,
  ARCHIVE_ENQUIRY_SUCCESS,
  ARCHIVE_ENQUIRY_FAILED,

  //UNARCHIVE ENQUIRY
  UNARCHIVE_ENQUIRY_START,
  UNARCHIVE_ENQUIRY_SUCCESS,

  //VIEW ENQUIRY
  VIEW_ENQUIRY_START,
  VIEW_ENQUIRY_SUCCESS,
  VIEW_ENQUIRY_FAILED,

  //UNREAD ENQUIRY
  MARK_ENQUIRY_UNREAD_START,
  MARK_ENQUIRY_UNREAD_SUCCESS,
  MARK_ENQUIRY_UNREAD_FAILED,

  //TIMELINE
  FETCH_TIMELINE_START,
  FETCH_TIMELINE_SUCCUSS,
  FETCH_TIMELINE_FAILED,
  /////////

  //FETCH BRANCH ENQUIRIES
  FETCH_BRANCH_ENQUIRIES_START,
  FETCH_BRANCH_ENQUIRIES_SUCCESS,
  FETCH_BRANCH_ENQUIRIES_FAILED,
  /////////
} from "../store/types";

import { isEmpty } from "../other/Utils";
import { cloud_function_server_url } from "config";
//import localforage from "localforage";


const CACHE_KEY = "branchEnquiriesCache";
const LAST_FETCH_KEY = "branchEnquiriesLastFetch";


export const clearEnquiryErrors = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_ENQUIRY_ERROR,
    payload: null,
  });
};

export const clearPullforwardEnquirySuccess = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_PULLFORWARD_ENQUIRY_SUCCESS,
    payload: null,
  });
};

const createString = (initString, array) =>
  new Promise((resolve, reject) => {
    let string = initString ? initString : "";

    for (let index = 0; index < array.length; index++) {
      const element = array[index];

      string += `,${element}`;

      if (index === array.length - 1) {
        resolve(string);
      }
    }
  });

const sperateAreas = (area) => {
  try {
    let lastAreaIndex = 0;
    let areaCount = 0;
    let commaCount = 0;
    let subAreas = [];
    for (let index = 0; index < area.length; index++) {
      const element = area[index];

      if (element === ",") {
        commaCount++;
        if (commaCount % 1 === 0) {
          areaCount++;
          lastAreaIndex = index + 1;
        }
      }

      if (index === area.length - 1) {
        let lastArea = area.slice(lastAreaIndex, area.length);
        return lastArea.trim();
      }
    }
  } catch (error) {
    return Promise.reject("Failure", error);
  }
};

export const addtoEnquiryTimeline =
  (enquiryData, eventData) => (dispatch) => (firebase) => {
    const { EnquiryTimeLineRef, auth, api } = firebase;

    try {
      if (eventData) {
        EnquiryTimeLineRef(enquiryData.id)
          .push(eventData)
          .then(() => { })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: ENQUIRY_ERROR,
          payload: "Please Provide eventData",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const fetchformEnquiryTimeline =
  (enquiryId) => (dispatch) => (firebase) => {
    const { EnquiryTimeLineRef } = firebase;

    try {
      dispatch({
        type: FETCH_TIMELINE_START,
        payload: null,
      });

      EnquiryTimeLineRef(enquiryId).on("value", (snapshot) => {
        if (snapshot.val()) {
          dispatch({
            type: FETCH_TIMELINE_SUCCUSS,
            payload: Object.values(snapshot.val()),
          });
        }
      });
    } catch (error) {
      dispatch({
        type: FETCH_TIMELINE_FAILED,
        payload: error,
      });
      console.log("error", error);
    }
  };

export const fetchSingleEnquiry = (Data) => (dispatch) => (firebase) => {
  try {
    const { singleEnquiryRef } = firebase;

    dispatch({
      type: FETCH_ENQUIRY_START,
      payload: null,
    });

    singleEnquiryRef(Data.id).on("value", (snapshot) => {
      let Enquiry = snapshot.val();

      if (Enquiry) {
        dispatch({
          type: FETCH_ENQUIRY_SUCCESS,
          payload: { ...Enquiry, id: Data.id },
        });
      }
    });
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const fetchCurrentAdminsBranchEnquiries =
  () => (dispatch) => (firebase) => {
    const { auth, EnquiryOfficeRef } = firebase;

    try {
      dispatch({
        type: FETCH_ENQUIRIES_START,
        payload: null,
      });

      let office = auth.currentUser.profile.adminHomeOffice;
      let activeEnquiries = [];
      let inactiveEnquiries = [];
      let collectiveEnquiries = { activeEnquiries, inactiveEnquiries };

      if (office) {
        EnquiryOfficeRef(office).once("value", (snapshot) => {
          if (snapshot.val()) {
            let enquiriesdataArr = Object.values(snapshot.val() ?? {});

            activeEnquiries = enquiriesdataArr.filter(
              (x) =>
                x.status === "Active"
            );
            inactiveEnquiries = enquiriesdataArr.filter(
              (x) =>

                x.status !== "Active"


            );

            collectiveEnquiries = {
              activeEnquiries: activeEnquiries.sort((a, b) => {
                let dateA = a.enquiryDate;
                let dateB = b.enquiryDate;

                return dateB - dateA; //For descending order
              }),

              inactiveEnquiries: inactiveEnquiries.sort((a, b) => {
                let dateA = a.enquiryDate;
                let dateB = b.enquiryDate;

                return dateB - dateA; //For descending order
              }),
            };

            if (
              collectiveEnquiries.activeEnquiries.length > 0 ||
              collectiveEnquiries.inactiveEnquiries.length > 0
            ) {
              dispatch({
                type: FETCH_BRANCH_ENQUIRIES_SUCCESS,
                payload: collectiveEnquiries,
              });
            } else {
              dispatch({
                type: ENQUIRY_ERROR,
                payload: `fetch error!, no enquries`,
              });
            }
          }
        });
      } else {
        dispatch({
          type: ENQUIRY_ERROR,
          payload: `fetch error!, no office provided`,
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
      });
    }
  };

export const fetchBranchesEnquiries = (branch) => (dispatch) => (firebase) => {
  try {
    const { singleEnquiryRef } = firebase;

    dispatch({
      type: FETCH_BRANCH_ENQUIRIES_START,
      payload: null,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      office: branch,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${cloud_function_server_url}/fetch_enquiries_by_office`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("enquiries", result);

        dispatch({
          type: FETCH_BRANCH_ENQUIRIES_SUCCESS,
          payload: result,
        });
      })
      .catch((error) => console.error(error));
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const fetchEnquriesFromOtherLocations =
  (uid) => (dispatch) => (firebase) => {
    const { EnquiryLocationRef, auth, singleUserRef, areasRef, EnquiryRef } =
      firebase;
    try {
    } catch (error) {
      console.log(error);
    }
  };

export const fetchAllBrokenEnquiriesByArea = () => (dispatch) => (firebase) => {
  const { EnquiryLocationRef, auth, singleUserRef, areasRef } = firebase;
};

export const fetchUserEnquiryhistory =
  (uid, office) => (dispatch) => (firebase) => {
    const { EnquiryLocationRef, auth } = firebase;
    try {
      dispatch({
        type: FETCH_ENQUIRIES_START,
        payload: null,
      });

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      console.log("office", office);

      const raw = JSON.stringify({
        brokerId: uid,
        office: office,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(`${cloud_function_server_url}/fetch_enquiries`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          dispatch({
            type: FETCH_ENQUIRIES_SUCCESS,
            payload: result,
          });
        })
        .catch((error) => {
          dispatch({
            type: FETCH_ENQUIRIES_FAILED,
            payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
          });
        });
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
      });
    }
  };

export const DeleteEnquiry =
  (deleteEnquiryData) => (dispatch) => (firebase) => {
    //all that is required for this is a confirmation that the user wants to delete the enquiry and the id of the enquiry that the user wants to delete
    const { singleEnquiryRef, auth } = firebase;

    try {
      dispatch({
        type: DELETE_ENQUIRY_START,
        payload: null,
      });

      if (deleteEnquiryData.confirmation === true) {
        singleEnquiryRef(deleteEnquiryData.id)
          .remove()
          .then(() => {
            dispatch({
              type: DELETE_ENQUIRY_SUCCESS,
              payload: deleteEnquiryData.id,
            });
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: DELETE_ENQUIRY_FAILED,
          payload: `Did not get proper permissions to delete`,
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
      });
    }
  };

export const UpdateEnquiry =
  (UpdatedEnquiryData) => (dispatch) => (firebase) => {
    //Please send the full Enquiry object with the update data and the data that was not updated
    const { singleEnquiryRef, auth, api, EnquiryRef } = firebase;
    dispatch({
      type: UPDATE_ENQUIRY_START,
      payload: null,
    });
    try {
      if (UpdatedEnquiryData) {


        // 🔧 Normalise offices into { officeName: true }
        if (Array.isArray(UpdatedEnquiryData.offices) && UpdatedEnquiryData.offices.length > 0) {
          UpdatedEnquiryData.offices = Object.fromEntries(
            UpdatedEnquiryData.offices.map((office) => [office, true])
          );
        }


        const UpdatedEnquiry = {
          ...UpdatedEnquiryData,
          modifiedDate: Date.now(),
          updatedBy: auth.currentUser.uid,
        };


        singleEnquiryRef(UpdatedEnquiryData?.id)
          .update(UpdatedEnquiry)
          .then(() => {

            dispatch({
              type: UPDATE_ENQUIRY_SUCCESS,
              payload: UpdatedEnquiry,
            });

            if (!UpdatedEnquiry.privacy && !UpdatedEnquiry.DoNotDisturb) {





              if ((UpdatedEnquiry.shareOffice && !UpdatedEnquiry.shareRegion) && UpdatedEnquiry.offices) {
                for (const office of Object.keys(UpdatedEnquiry.offices)) {
                  dispatch(
                    api.SendBulkPushNotification({
                      office: office,
                      title: "Updated Enquiry In your Office",
                      msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has updated an Enquiry in your office`,
                      content: {
                        type: "Enquiry",
                        content: UpdatedEnquiry,
                      },
                    })
                  );
                }
              }

              if (UpdatedEnquiry.shareBrokers && UpdatedEnquiry.shareBrokers.length > 0) {
                dispatch(
                  api.SendBulkPushNotification({
                    brokers: UpdatedEnquiry.shareBrokers,
                    title: "Updated Enquiry you are added to",
                    msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has updated an Enquiry that you're tagged in`,
                    content: {
                      type: "Enquiry",
                      content: UpdatedEnquiry,
                    },
                  })
                );
              }

              if (UpdatedEnquiry.shareRegion && UpdatedEnquiry.regions.length > 0) {
                for (const region of UpdatedEnquiry.regions) {
                  dispatch(
                    api.SendBulkPushNotification({
                      region: region,
                      title: "Updated Enquiry in your Region",
                      msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has updated an Enquiry in your Region`,
                      content: {
                        type: "Enquiry",
                        content: UpdatedEnquiry,
                      },
                    })
                  );
                }
              }



            }


            dispatch(api.ViewedEnquiry(UpdatedEnquiry));
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: UPDATE_ENQUIRY_FAILED,
          payload: "Please double check inputted data",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const AddEnquiryToCallList =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { callListEnquiryRef, auth, api } = firebase;
    dispatch({
      type: ADD_ENQUIRY_TO_CALLLIST_START,
      payload: null,
    });
    try {
      if (EnquiryData && EnquiryData?.id) {
        callListEnquiryRef(EnquiryData.id)
          .push({
            brokerId: auth.currentUser.uid,
          })
          .then((res) => {
            let BrokerCallList = {
              ...EnquiryData.BrokerCallList,
              [res.key]: { brokerId: auth.currentUser.uid },
            };

            EnquiryData = {
              ...EnquiryData,
              BrokerCallList,
            };

            dispatch({
              type: ADD_ENQUIRY_TO_CALLLIST_SUCCUSS,
              payload: EnquiryData,
            });
            dispatch(api.ViewedEnquiry(EnquiryData));
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: ARCHIVE_ENQUIRY_FAILED,
          payload: "No Id found for equiry, if this issue persistes please contact an admin",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const AddEnquiryToWhiteboard =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { whiteboardEnquiryRef, auth, api } = firebase;
    dispatch({
      type: ADD_ENQUIRY_TO_WHITEBOARD_START,
      payload: null,
    });
    try {
      if (EnquiryData && EnquiryData?.id) {
        whiteboardEnquiryRef(EnquiryData.id)
          .push({
            brokerId: auth.currentUser.uid,
          })
          .then((res) => {
            let BrokerWhiteboard = {
              ...EnquiryData.BrokerWhiteboard,
              [res.key]: { brokerId: auth.currentUser.uid },
            };

            EnquiryData = {
              ...EnquiryData,
              BrokerWhiteboard,
            };

            dispatch({
              type: ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS,
              payload: EnquiryData,
            });
            dispatch(api.ViewedEnquiry(EnquiryData));
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: ARCHIVE_ENQUIRY_FAILED,
          payload: "No Id found for equiry, if this issue persistes please contact an admin",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const AddEnquiryToInvestor =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { investorsEnquiryRef, auth, api } = firebase;
    dispatch({
      type: ADD_ENQUIRY_TO_INVESTOR_START,
      payload: null,
    });
    try {
      console.log('Enq', Object.keys(EnquiryData))
      if (EnquiryData && EnquiryData?.id) {
        investorsEnquiryRef(EnquiryData.id)
          .push({
            brokerId: auth.currentUser.uid,
          })
          .then((res) => {
            let BrokerInvestors = {
              ...EnquiryData.BrokerInvestors,
              [res.key]: { brokerId: auth.currentUser.uid },
            };

            EnquiryData = {
              ...EnquiryData,
              BrokerInvestors,
            };

            dispatch({
              type: ADD_ENQUIRY_TO_INVESTOR_SUCCESS,
              payload: EnquiryData,
            });
            dispatch(api.ViewedEnquiry(EnquiryData));
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: ARCHIVE_ENQUIRY_FAILED,
          payload: "No Id found for equiry, if this issue persistes please contact an admin",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const RemoveEnquiryFromCallList =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { removeFromCallListEnquiryRef, auth, api } = firebase;
    dispatch({
      type: REMOVE_ENQUIRY_FROM_CALLLIST_START,
      payload: null,
    });
    try {
      if (EnquiryData) {
        let brokersInCallList = EnquiryData?.BrokerCallList
          ? Object.entries(EnquiryData?.BrokerCallList)
          : [];

        if (brokersInCallList?.length > 0) {
          let brokerInCallList = brokersInCallList.find(
            (x) => x[1].brokerId === auth?.currentUser?.uid
          );

          if (brokerInCallList) {
            const BrokerCallListId = brokerInCallList[0];

            removeFromCallListEnquiryRef(EnquiryData.id, BrokerCallListId)
              .remove()
              .then(() => {
                let BrokerCallList = brokersInCallList.filter(
                  (x) => x[1].brokerId !== auth?.currentUser?.uid
                );

                EnquiryData = {
                  ...EnquiryData,
                  BrokerCallList,
                };

                dispatch({
                  type: REMOVE_ENQUIRY_FROM_CALLLIST_SUCCESS,
                  payload: EnquiryData,
                });
              })
              .catch((error) => {
                dispatch({
                  type: ENQUIRY_ERROR,
                  payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
                });
              });
          }
        } else {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: "No Id found for equiry, if this issue persistes please contact an admin",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const RemoveEnquiryFromWhiteboard =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { removeFromWhiteboardEnquiryRef, auth, api } = firebase;
    dispatch({
      type: REMOVE_ENQUIRY_FROM_WHITEBOARD_START,
      payload: null,
    });
    try {
      if (EnquiryData) {
        let brokersInWhiteboardList = EnquiryData?.BrokerWhiteboard
          ? Object.entries(EnquiryData?.BrokerWhiteboard)
          : [];

        if (brokersInWhiteboardList?.length > 0) {
          let brokerInWhiteboardList = brokersInWhiteboardList.find(
            (x) => x[1].brokerId === auth?.currentUser?.uid
          );

          if (brokerInWhiteboardList) {
            const BrokerWhiteboardListId = brokerInWhiteboardList[0];

            removeFromWhiteboardEnquiryRef(
              EnquiryData.id,
              BrokerWhiteboardListId
            )
              .remove()
              .then(() => {
                let BrokerWhiteboard = brokersInWhiteboardList.filter(
                  (x) => x[1].brokerId !== auth?.currentUser?.uid
                );

                console.log('BrokerWhiteboardList', BrokerWhiteboard)

                EnquiryData = {
                  ...EnquiryData,
                  BrokerWhiteboard,
                };

                dispatch({
                  type: REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS,
                  payload: EnquiryData,
                });
              })
              .catch((error) => {
                dispatch({
                  type: ENQUIRY_ERROR,
                  payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
                });
              });
          }
        } else {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: "No Id found for equiry, if this issue persistes please contact an admin",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const RemoveEnquiryFromInvestor =
  (EnquiryData) => (dispatch) => (firebase) => {
    const { removeFromInvestorEnquiryRef, auth, api } = firebase;
    dispatch({
      type: REMOVE_ENQUIRY_FROM_INVESTOR_START,
      payload: null,
    });
    try {
      if (EnquiryData) {
        let brokersInInvestorList = EnquiryData?.BrokerInvestors
          ? Object.entries(EnquiryData?.BrokerInvestors)
          : [];

        if (brokersInInvestorList?.length > 0) {
          let brokerInInvestorList = brokersInInvestorList.find(
            (x) => x[1].brokerId === auth?.currentUser?.uid
          );

          if (brokerInInvestorList) {
            const BrokerInvestorListId = brokerInInvestorList[0];
            console.log(`In if statement`);

            removeFromInvestorEnquiryRef(EnquiryData.id, BrokerInvestorListId)
              .remove()
              .then(() => {
                let BrokerInvestors = brokersInInvestorList.filter(
                  (x) => x[1].brokerId !== auth?.currentUser?.uid
                );

                EnquiryData = {
                  ...EnquiryData,
                  BrokerInvestors,
                };

                dispatch({
                  type: REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS,
                  payload: EnquiryData,
                });
              })
              .catch((error) => {
                dispatch({
                  type: ENQUIRY_ERROR,
                  payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
                });
              });
          }
        } else {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: "No Id found for equiry, if this issue persistes please contact an admin",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

const fetchBrokersAreas = (brokerList, userIdRef) =>
  new Promise((resolve, reject) => {
    let returnedAreas = [];



    for (let brokerIndex = 0; brokerIndex < brokerList.length; brokerIndex++) {
      const element = brokerList[brokerIndex];
      userIdRef(element).on("value", (snapshot) => {
        let Areas = Object.values(snapshot.val().Areas ? snapshot.val().Areas : {});
        if (Areas.length > 0) {
          for (let index = 0; index < Areas.length; index++) {
            const area = sperateAreas(Areas[index]);
            returnedAreas.push(area);

            if (
              brokerIndex === brokerList.length - 1 &&
              index === Areas.length - 1
            ) {
              resolve(returnedAreas);
            }
          }
        } else {
          reject("One or more brokers dont have areas please try again");
        }

      });
    }
  });

const fetchBroker = (userId, userIdRef) =>
  new Promise((resolve, reject) => {
    userIdRef(userId).on("value", (snapshot) => {
      let brokerInfo = snapshot.val();

      resolve(brokerInfo);
    });
  });

export const CreateEnquiry =
  (EnquiryData, Brokers) => (dispatch) => async (firebase) => {
    const { api, EnquiryLocationRef, auth, userIdRef, SingleRegionRef } = firebase;

    try {
      dispatch({
        type: CREATE_ENQUIRY_START,
        payload: null,
      });

      if (EnquiryData) {
        let ErrorArray = [];
        let mainArea = EnquiryData.address.suburb;
        let areas;
        let suburb;
        let ownerBroker;

        if (ErrorArray.length > 0) {
          dispatch({
            type: CREATE_ENQUIRY_FAILED,
            payload: ErrorArray,
          });
          return;
        }

        if (EnquiryData.shareBrokers.length > 0) {
          areas = await fetchBrokersAreas(
            EnquiryData.shareBrokers,
            userIdRef
          ).catch((message) => {
            dispatch({
              type: CREATE_ENQUIRY_FAILED,
              payload: `${message}`,
            });
          });

          if (areas) {
            suburb = await createString(
              sperateAreas(EnquiryData.address.suburb),
              areas
            );
            areas.unshift(sperateAreas(EnquiryData.address.suburb));
          } else {
            return;
          }
        }

        if (EnquiryData.ownerBroker) {
          ownerBroker = await fetchBroker(EnquiryData.ownerBroker, userIdRef);
        }

        // 🔧 Normalise offices into { officeName: true }
        if (Array.isArray(EnquiryData.offices) && EnquiryData.offices.length > 0) {
          EnquiryData.offices = Object.fromEntries(
            EnquiryData.offices.map((office) => [office, true])
          );
        }

        EnquiryData = {
          ...EnquiryData,
          CreatedAt: Date.now(),
          timeline: {
            0: {
              time: Date.now(),
              title: "Enquiry Created",
            },
          },
          suburbs: EnquiryData.selectedArea, // now uses the selectedArea instead of suburb
          address: {
            suburb: EnquiryData.selectedArea,
          },
          userdetials: {
            id: ownerBroker ? EnquiryData.ownerBroker : auth.currentUser.uid,
            email: ownerBroker ? ownerBroker.email : auth.currentUser.email,
            mobile: ownerBroker
              ? ownerBroker.mobile
              : auth.currentUser.profile.mobile,
            Name: ownerBroker
              ? ownerBroker.firstName
              : auth.currentUser.profile.firstName,
            lastName: ownerBroker
              ? ownerBroker.lastName
              : auth.currentUser.profile.lastName,
            profile: ownerBroker
              ? ownerBroker.profile_image
                ? ownerBroker.profile_image
                : null
              : auth.currentUser.profile.profile_image
                ? auth.currentUser.profile.profile_image
                : null,
          },
        };

        EnquiryLocationRef()
          .push(EnquiryData)
          .then((res) => {
            var id = res.key;
            EnquiryData.id = id;
            dispatch(api.UpdateEnquiry({ ...EnquiryData, id: id, DoNotDisturb: true }));
            dispatch(api.CreateChat({ ...EnquiryData, Brokers: Brokers }));

            if (!EnquiryData.privacy) {
              if ((EnquiryData.shareOffice && !EnquiryData.shareRegion) && EnquiryData.offices) {
                for (const office of Object.keys(EnquiryData.offices)) {
                  dispatch(
                    api.SendBulkPushNotification({
                      office: office,
                      title: "New Enquiry In your Office",
                      msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has shared an Enquiry with your office`,
                      content: {
                        type: "Enquiry",
                        content: EnquiryData,
                      },
                    })
                  );
                }
              }

              if (EnquiryData.shareBrokers && EnquiryData.shareBrokers.length > 0) {
                dispatch(
                  api.SendBulkPushNotification({
                    brokers: EnquiryData.shareBrokers,
                    title: "You were added to an enquiry",
                    msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has added you to an enquiry`,
                    content: {
                      type: "Enquiry",
                      content: EnquiryData,
                    },
                  })
                );
              }

              if (EnquiryData.shareRegion && EnquiryData.regions.length > 0) {
                for (const region of EnquiryData.regions) {
                  dispatch(
                    api.SendBulkPushNotification({
                      region: region,
                      title: "New Enquiry In your Region",
                      msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has shared an Enquiry with your Region`,
                      content: {
                        type: "Enquiry",
                        content: EnquiryData,
                      },
                    })
                  );
                }
              }
            }

            dispatch({
              type: CREATE_ENQUIRY_SUCCESS,
              payload: EnquiryData,
            });
          })
          .catch((error) => {
            console.log("error", error);
            dispatch({
              type: CREATE_ENQUIRY_FAILED,
              payload: `Sorry we received an error ,\n ${error.code} : ${error.message}`,
            });
          });
      }
    } catch (error) {
      console.log("error", error);
      dispatch({
        type: CREATE_ENQUIRY_FAILED,
        payload: `Sorry we received an error ,\n ${error}`,
      });
    }
  };


export const PullforwardEnquiryForAll = (EnquiryData) => (dispatch) => (firebase) => {
  const { auth, pullforwardEnquiryRef, singleEnquiryRef } = firebase;
  dispatch({
    type: UPDATE_ENQUIRY_START,
    payload: null,
  });
  try {
    if (EnquiryData) {
      const enquiryDataPullforward = EnquiryData?.pullforward;

      pullforwardEnquiryRef(EnquiryData.id)
        .update({
          pullforward: enquiryDataPullforward.pullforward,
          pullforwardNote: enquiryDataPullforward.pullforwardNote,
          pullforwardDate: enquiryDataPullforward.pullforwardDate,
          pullforwardBrokers: enquiryDataPullforward.pullforwardBrokers,
          createdBy: enquiryDataPullforward.createdBy,
          modifiedDate: enquiryDataPullforward.modifiedDate,
          pullforwardType: enquiryDataPullforward.pullforwardType,
        })
        .then(() => {
          singleEnquiryRef(EnquiryData.id).update({
            status: "pullforward",
            updatedBy: enquiryDataPullforward.createdBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
          })

          dispatch({
            type: UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
            payload: EnquiryData,
            msg: `Enquiry has been successfully pull forwarded`
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: UPDATE_ENQUIRY_FAILED,
        payload: "Enquiry data cannot be null",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
    });
  }
};

export const RemovePullforwardForAll =
  (UpdatedEnquiryData) => (dispatch) => (firebase) => {
    //Please send the full Enquiry object with the update data and the data that was not updated
    const { singleEnquiryRef, auth, api, EnquiryRef } = firebase;
    dispatch({
      type: UPDATE_ENQUIRY_START,
      payload: null,
    });
    try {
      if (UpdatedEnquiryData) {
        singleEnquiryRef(UpdatedEnquiryData?.id)
          .set(UpdatedEnquiryData)
          .then(() => {

            dispatch({
              type: UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
              payload: UpdatedEnquiryData,
              msg: "Enquiry has been removed from pull forward for all"
            });

            dispatch(api.ViewedEnquiry(UpdatedEnquiryData));
          })
          .catch((error) => {
            dispatch({
              type: ENQUIRY_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: UPDATE_ENQUIRY_FAILED,
          payload: "Please double check inputted data",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };


export const PullforwardEnquiryForMe = (EnquiryData) => (dispatch) => (firebase) => {
  const { auth, pullforwardEnquiryRef, singleEnquiryRef } = firebase;
  dispatch({
    type: UPDATE_ENQUIRY_START,
    payload: null,
  });
  try {
    if (EnquiryData) {
      const enquiryDataPullforward = EnquiryData?.pullforward;

      pullforwardEnquiryRef(EnquiryData.id)
        .update({
          pullforward: enquiryDataPullforward.pullforward,
          pullforwardNote: enquiryDataPullforward.pullforwardNote,
          pullforwardDate: enquiryDataPullforward.pullforwardDate,
          pullforwardBrokers: enquiryDataPullforward.pullforwardBrokers,
          updatedBy: enquiryDataPullforward.updatedBy,
          modifiedDate: enquiryDataPullforward.modifiedDate,
          createdBy: enquiryDataPullforward.createdBy,
        })
        .then(() => {
          singleEnquiryRef(EnquiryData.id).update({
            updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
          })

          let pullforwardBrokers = {
            ...EnquiryData.pullforward,
            pullforwardBrokers: ([...enquiryDataPullforward.pullforwardBrokers, auth.currentUser.uid] || [])
              .filter(broker => broker !== undefined && broker !== null),
          };

          EnquiryData = {
            ...EnquiryData,
            updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
            pullforward: {
              ...EnquiryData.pullforward,
              pullforwardBrokers: pullforwardBrokers.pullforwardBrokers,
              updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
              modifiedDate: new Date().getTime(),
            },
          };

          dispatch({
            type: UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
            payload: EnquiryData,
            msg: `Enquiry has been successfully pull forwarded for you`
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: UPDATE_ENQUIRY_FAILED,
        payload: "No Id found for equiry, if this issue persistes please contact an admin",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
  }
};

export const RemovePullforwardEnquiryForMe = (EnquiryData) => (dispatch) => (firebase) => {
  const { auth, pullforwardEnquiryRef, singleEnquiryRef, removePullforwardEnquiryForMeRef } = firebase;
  dispatch({
    type: UPDATE_ENQUIRY_START,
    payload: null,
  });
  try {
    if (EnquiryData) {
      pullforwardEnquiryRef(EnquiryData.id)
        .update({
          pullforwardBrokers: (EnquiryData.pullforward.pullforwardBrokers || null)
            .filter(broker => broker !== undefined && broker !== null),
          updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
          modifiedDate: new Date().getTime()
        })
        .then(() => {
          singleEnquiryRef(EnquiryData.id).update({
            updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
          })

          let pullforwardBrokers = {
            ...EnquiryData,
            updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
            ...EnquiryData.pullforward,
            pullforwardBrokers: EnquiryData?.pullforward?.pullforwardBrokers
              ? EnquiryData?.pullforward?.pullforwardBrokers.filter((broker) => broker !== auth.currentUser.uid)
              : []
            ,
            updatedBy: EnquiryData?.pullforward?.updatedBy || auth.currentUser.uid,
            modifiedDate: new Date().getTime(),
          };

          EnquiryData = pullforwardBrokers

          dispatch({
            type: UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
            payload: EnquiryData,
            msg: `Enquiry has been successfully removed from your pull forwards`
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
          console.log(`Error: ${error}`)
        });
    } else {
      dispatch({
        type: UPDATE_ENQUIRY_FAILED,
        payload: "No Id found for equiry, if this issue persistes please contact an admin",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
    console.log(`Error 2: ${error}`)
  }
};

export const ArchiveEnquiry = (EnquiryData) => (dispatch) => (firebase) => {
  const { archiveEnquiryRef, auth, api } = firebase;
  dispatch({
    type: ARCHIVE_ENQUIRY_START,
    payload: null,
  });
  try {
    if (EnquiryData) {
      archiveEnquiryRef(EnquiryData.id)
        .push({
          brokerId: auth.currentUser.uid,
          archivedDate: new Date().getTime() + 1209600000,
        })
        .then((res) => {
          let archivedbroker = {
            ...EnquiryData.archivedbroker,
            [res.key]: {
              brokerId: auth.currentUser.uid,
              archivedDate: new Date().getTime() + 1209600000,
            },
          };

          EnquiryData = {
            ...EnquiryData,
            archivedbroker,
          };

          dispatch({
            type: ARCHIVE_ENQUIRY_SUCCESS,
            payload: EnquiryData,
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: ARCHIVE_ENQUIRY_FAILED,
        payload: "No Id found for equiry, if this issue persistes please contact an admin",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
  }
};

export const ViewedEnquiry = (EnquiryData) => (dispatch) => (firebase) => {
  const { ViewEnquiryRef, auth, api } = firebase;
  dispatch({
    type: VIEW_ENQUIRY_START,
    payload: null,
  });
  try {
    console.log('EnquiryData', EnquiryData)
    if (EnquiryData) {
      ViewEnquiryRef(EnquiryData.id)
        .push(auth.currentUser.uid)
        .then((res) => {
          let viewedBy = {
            ...EnquiryData.viewedBy,
            [res.key]: auth.currentUser.uid,
          };

          EnquiryData = {
            ...EnquiryData,
            viewedBy,
          };

          dispatch({
            type: VIEW_ENQUIRY_SUCCESS,
            payload: EnquiryData,
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: VIEW_ENQUIRY_FAILED,
        payload: "No Id found for equiry, if this issue persistes please contact an admin",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
  }
};

//Mark the enquiry as unread
export const UnreadEnquiry = (EnquiryData) => (dispatch) => (firebase) => {
  const { UnreadEnquiryRef, auth, api } = firebase;
  dispatch({
    type: MARK_ENQUIRY_UNREAD_START,
    payload: null,
  });
  try {
    if (EnquiryData) {
      let viewedBrokers = EnquiryData.viewedBy
        ? Object.entries(EnquiryData.viewedBy)
        : [];

      if (viewedBrokers?.length > 0) {
        console.log(auth?.currentUser?.uid);
        let viewedByBroker = viewedBrokers.find(
          (x) => x[1] === auth?.currentUser?.uid
        );

        if (viewedByBroker) {
          const viewId = viewedByBroker[0];
          UnreadEnquiryRef(EnquiryData.id, viewId)
            .remove()
            .then(() => {
              let viewedBy = viewedBrokers.filter(
                (x) => x[1] !== auth?.currentUser?.uid
              );

              EnquiryData = {
                ...EnquiryData,
                viewedBy,
              };

              dispatch({
                type: MARK_ENQUIRY_UNREAD_SUCCESS,
                payload: EnquiryData,
              });
            })
            .catch((error) => {
              dispatch({
                type: ENQUIRY_ERROR,
                payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
              });
            });
        }
      } else {
        dispatch({
          type: MARK_ENQUIRY_UNREAD_SUCCESS,
          payload: "No Id found for equiry, if this issue persistes please contact an admin",
        });
      }
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
  }
};

export const UnarchiveEnquiry = (EnquiryData) => (dispatch) => (firebase) => {
  const { UnarchiveEnquiryRef, auth, api } = firebase;
  dispatch({
    type: UNARCHIVE_ENQUIRY_START,
    payload: null,
  });

  try {
    if (EnquiryData) {
      let archivedbrokers = EnquiryData.archivedbroker
        ? Object.entries(EnquiryData.archivedbroker)
        : [];

      UnarchiveEnquiryRef(EnquiryData.id, EnquiryData.archiveData.archiveId)
        .remove()
        .then(() => {
          let archivedbroker = archivedbrokers.filter(
            (x) => x[1].brokerId !== auth?.currentUser?.uid
          );

          EnquiryData = {
            ...EnquiryData,
            archivedbroker,
          };

          dispatch({
            type: UNARCHIVE_ENQUIRY_SUCCESS,
            payload: EnquiryData,
          });
        })
        .catch((error) => {
          dispatch({
            type: ENQUIRY_ERROR,
            payload: `Sorry, we encountered an error,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: ARCHIVE_ENQUIRY_FAILED,
        payload: "",
      });
    }
  } catch (error) {
    dispatch({
      type: ENQUIRY_ERROR,
      payload: error,
    });
  }
};
